import * as React from 'react'
import MenuItem from '@mui/material/MenuItem'
import { ListSubheader, Select, SelectChangeEvent, Tooltip, Typography } from '@mui/material'
import { appdata } from '../internalModules'
import { dialogTypographyStyle, rowHeight } from '../Graphics'
import UIMemberIcon from './UIMemberIcon'
import { groupBy } from '../utility'

type Props = {
  label: string
  memberGuid: string
  handleChange: ((event: SelectChangeEvent<string>, child: React.ReactNode) => void) | undefined
  memberClassFilter?: string[]
}

export default function UISelectMember( {label, memberGuid, handleChange, memberClassFilter = []}: Props ) {

  let memberArray = appdata.getMemberArray(memberClassFilter)
  const grouped = groupBy(memberArray, ['category'])
  const sortedCategories = Object.keys(grouped).sort( (a,b) => a.localeCompare(b))

  return (
    <>
      <Tooltip title='Select a member from the list or use the "Framing" menu to create new framing members.' arrow placement='left'>
        <Typography sx={dialogTypographyStyle} color='secondary'>{label}</Typography>
      </Tooltip>
      <Select
        size='small'
        style={{height: 42}}
        SelectDisplayProps={{ style: {display: 'flex', alignItems: 'center'} }}
        fullWidth
        labelId='member-select-label'
        value={memberGuid}
        name='memberGuid'
        onChange={handleChange}
      >
        <MenuItem disabled value=''>
          <em>Use "Framing" menu to create new framing members...</em>
        </MenuItem>
        {sortedCategories.map( category => [
          <ListSubheader color={'primary'} sx={{fontSize:'18px'}} key={category}>{category}</ListSubheader>,
          grouped[category].sort( (a,b) => a.name.localeCompare(b.name)).map( m=> (
            <MenuItem sx={{paddingLeft:4}} key={m.guid} value={m.guid}>
              <UIMemberIcon kind={m.kind}/>
              {m.name}
            </MenuItem>
          ))
        ])}
      </Select>
    </>  
  )

}
